import BasePlatformStore from '@swipe-guide/clients-shared/stores/platform';
import {observable, action, computed, makeObservable} from 'mobx';
import {client} from 'utils/apollo-client';
class PlatformStore extends BasePlatformStore {
  @observable id;
  @observable name = '';
  @observable assetsFolder;
  @observable currentLanguage;
  @observable localeMessages = {};
  @observable notFound = false;

  constructor() {
    super(client);
    makeObservable(this);
  }

  /* START TEMPORARY DUPLICATE BETWEEN MOBILE & CLIENT */
  @observable availableLanguages;

  @action setAvailablelanguages = val => {
    this.availableLanguages = val;
    this.initIntlProvider();
  };

  @action
  initIntlProvider = () => {
    const localeMessages = {};

    this.availableLanguages.forEach(language => {
      const fullLocale = this.getLocalMapping(language.locale);
      localeMessages[fullLocale] = require(`translations/${fullLocale}.json`);
    });

    this.localeMessages = localeMessages;
  };

  @action
  setIconsShowHintLabel = showStepNoteIconLabel => {
    this.showStepNoteIconLabel = showStepNoteIconLabel;
  };

  @action
  setCurrentLanguage = val => {
    const normalizedLanguage = this.toDashLocale(val);
    this.currentLanguage = normalizedLanguage;
    this.setLocalLanguage(normalizedLanguage);
  };

  @action
  setLanguageWithoutReload = language => {
    const normalizedLanguage = this.toDashLocale(language);
    this.setLocalLanguage(normalizedLanguage);
    this.setCurrentLanguage(normalizedLanguage);
  };

  @action
  setPlatformId = id => (this.id = id);

  @action
  setPlatformName = name => (this.name = name);

  @action
  setDomain = domain => (this.domain = domain);

  setAssetsFolder = assetsFolder => {
    this.assetsFolder = assetsFolder;
  };

  @computed
  get selectedLocale() {
    return this.availableLanguages.find(lang => lang.locale === this.toUnderscoreLocale(this.currentLanguage));
  }

  @computed
  get activeLocale() {
    return this.currentLanguage ? this.currentLanguage : this.browserLocale;
  }
  /* END TEMPORARY DUPLICATE BETWEEN MOBILE & CLIENT */

  @action setNotFound = value => (this.notFound = value);
}

export default PlatformStore;
